export default __webpack_public_path__ + "static/media/u4.cace2bcd.svg";